import { SharePointError } from './retry';

export interface ErrorLogContext {
  component: string;
  action: string;
  userEmail?: string;
  severity?: 'Error' | 'Warning';
}

interface ErrorLoggerConfig {
  siteUrl: string;
  getAccessToken: () => Promise<string>;
}

class ErrorLogger {
  private config: ErrorLoggerConfig | null = null;

  init(config: ErrorLoggerConfig): void {
    this.config = config;
  }

  log(error: unknown, context: ErrorLogContext): void {
    const err = error instanceof Error ? error : new Error(String(error));
    console.error(`[${context.component}/${context.action}]`, err);
    void this.persist(err, context);
  }

  private async persist(error: Error, context: ErrorLogContext): Promise<void> {
    if (!this.config) return;

    try {
      const token = await this.config.getAccessToken();
      const statusCode = error instanceof SharePointError ? error.statusCode : null;
      const baseUrl = this.config.siteUrl.replace(/\/$/, '');

      const body: Record<string, unknown> = {
        Title: `${context.component}: ${error.message}`.slice(0, 255),
        ErrorMessage: error.message,
        StackTrace: error.stack ?? '',
        ComponentName: context.component,
        ActionName: context.action,
        UserEmail: context.userEmail ?? '',
        Severity: context.severity ?? 'Error',
      };
      if (statusCode !== null) body['HttpStatusCode'] = statusCode;

      await globalThis.fetch(
        `${baseUrl}/_api/web/lists/getbytitle('Error Logs')/items`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json;odata=nometadata',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(body),
        }
      );
    } catch {
      // Never throw from the error logger — swallow failures silently
    }
  }
}

export const errorLogger = new ErrorLogger();
